import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Subscription } from 'rxjs';

import { IOpenResourceOptions, isDicomFile } from '@eai-tdv/core/models';
import { RESOURCE_TYPES } from '@eai-tdv/core/models';

import { IconSvgXComponent } from '@eai-tdv/shared/icon-svg';

import { UploadResourceService } from '../../upload-resource.service';
import { IUploadResourceItem } from '../../upload-resource.types';
import { UploadResourceProgressImgComponent } from './img/upload-resource-progress-img.component';
import { UploadResourceProgressInfoComponent } from './info/upload-resource-progress-info.component';

@Component({
  imports: [
    NgIf,
    AsyncPipe,
    NgClass,
    IconSvgXComponent,
    UploadResourceProgressImgComponent,
    UploadResourceProgressInfoComponent,
  ],
  selector: 'tdv-upload-resource-progress-item',
  templateUrl: './upload-resource-progress-item.component.html',
  styleUrls: ['./upload-resource-progress-item.component.scss'],
})
export class UploadResourceProgressItemComponent implements OnInit {
  @Input({ required: true }) public set item(v: IUploadResourceItem) {
    this.data = v;
    const nativeFile = v.nativeFile;
    this.isDicom = !!nativeFile && isDicomFile(nativeFile);
    this.initBase64Watcher(v);
    this.initHideUploadItemAfterUuuidReceive(v);
    this.uploadId = v.uploadId;
    if (v?.uploadResultWatcher?.value?.type) {
      this.resourceType = v?.uploadResultWatcher?.value.type;
    }

    this.isUuidReceived = Boolean(v.resourceUuidWatcher.value);
  }

  @Input({ required: true }) public set progress(v: number) {
    this.progressVal = v;
    this.isBlobLoaded = v === 100;
  }
  private readonly destroyRef = inject(DestroyRef);
  private readonly isOpenResourceOnUploadEnabled = false;
  public data!: IUploadResourceItem;
  private uploadId!: number;
  public progressVal!: number;
  public base64?: string;
  public isDicom = false;
  public isBlobLoaded?: boolean;
  private resourceType!: RESOURCE_TYPES;
  public isUuidReceived?: boolean;
  private base64subscription?: Subscription;
  private uploadResultSubscription?: Subscription;
  constructor(private uploadResourceS: UploadResourceService) {}

  public get canOpenResource(): boolean {
    return (
      this.isOpenResourceOnUploadEnabled &&
      !!this.isBlobLoaded &&
      !!this.isUuidReceived
    );
  }

  ngOnInit(): void {
    this.data.uploadResultWatcher.$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(result => {
      if (result?.type && !this.resourceType) {
        this.resourceType = result?.type;
      }
    });
  }

  public close(): void {
    this.uploadResourceS.closeItem(this.uploadId);
  }

  private initHideUploadItemAfterUuuidReceive(v?: IUploadResourceItem): void {
    if (v?.uploadResultWatcher.$) {
      this.uploadResultSubscription?.unsubscribe();
      this.uploadResultSubscription = v?.uploadResultWatcher.$.pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe(r => {
        if (r?.uuid) {
          setTimeout(() => {
            this.close();
          }, this.uploadResourceS.hideDelayMs);
        }
      });
    }
  }

  private initBase64Watcher(v?: IUploadResourceItem): void {
    if (v?.imageObjectWatcher.$) {
      this.base64subscription?.unsubscribe();
      this.base64subscription = v?.imageObjectWatcher.$.pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe(r => (this.base64 = r?.base64 as string));
    }
  }

  public openResource(): void {
    const params: IOpenResourceOptions = {
      patientUuid: this.data.patientUuid,
      resourceUuid: this.data.resourceUuidWatcher.value as string,
      resourceType: this.resourceType,
      resourceName: this.data.uploadResultWatcher.value?.name || null,
    };
    const isPatientProfileOpen = this.uploadResourceS.isPatientOpen$.value;
    if (isPatientProfileOpen) {
      this.uploadResourceS.openUploadedResource$.next(params);
    } else {
      // todo
    }
    this.close();
  }
}
